import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CourseIcon, RegistrationIcon, TestIcon } from "../icons";
import { routes } from "../helpers/constants";
import { useSelector } from "react-redux";

const Footer = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.userReducer);

  const getFooterLinks = () => {
    if (user?.user_role === "ADMIN") {
      return [
        {
          name: "REGISTRATION",
          icon: RegistrationIcon,
          link: routes.registration,
          hasNotification: false,
          notifications: 0,
          isActive: true,
          disabled: false,
          activePages: [routes.registration],
        },
      ];
    } else if (user?.user_role === "USER") {
      return [
        {
          name: "course",
          icon: CourseIcon,
          link: routes.courses,
          hasNotification: false,
          notifications: 0,
          isActive: true,
          disabled: false,
          activePages: [
            routes.courses,
            routes.courseModule,
            routes.moduleViewing,
          ],
        },
        // {
        //   name: "TEST",
        //   icon: TestIcon,
        //   link: routes.test,
        //   hasNotification: false,
        //   notifications: 0,
        //   isActive: true,
        //   disabled: false,
        //   activePages: [routes.test],
        // },
      ];
    } else {
      return [];
    }
  };

  return (
    <div className="lms-footer">
      <div className="lms-footer-content">
        {getFooterLinks().map((tab, index) => {
          if (tab.isActive) {
            return (
              <Link
                key={index}
                to={tab.link}
                className={`lms-footer-tab ${
                  location.pathname === tab.link
                    ? "active"
                    : tab.activePages.includes(location.pathname)
                    ? "active"
                    : ""
                } ${tab.disabled && "pe-none"}`}
              >
                {tab.icon}
                <span className="tab-label">{tab.name}</span>
              </Link>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default Footer;
